module.exports = ".inputfile {\n  position: absolute;\n  overflow: hidden;\n  z-index: -1;\n  opacity: 0; }\n\nlabel.btn {\n  margin: 0; }\n"